var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtmhomeright(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 139,
    viewBox: "0 0 467 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.48499e-05 92H46.7454L46.7454 138.745H-6.48499e-05L-6.48499e-05 92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7453 92H93.4907V138.745H46.7453L46.7453 92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.815 138.746H233.561V185.491H186.815V138.746Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.48499e-05 138.746H46.7454L46.7454 185.491H-6.48499e-05L-6.48499e-05 138.746Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.885 92H373.631V138.745H326.885V92Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4909 92H140.236V138.745H93.4909V92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7453 138.746H93.4907V185.491H46.7453L46.7453 138.746Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21 92H466.955V138.745H420.21V92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.815 92H233.561V138.745H186.815V92Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.394 92H280.14V138.745H233.394V92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 92H420.21V138.745H373.464V92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14 92H326.885V138.745H280.14V92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 92H186.815V138.745H140.07V92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 138.745H186.815V185.49H140.07V138.745Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.639 103.751L455.284 92.1062L466.929 103.751L455.284 115.397L443.639 103.751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.334 103.714L431.979 92.0684L443.624 103.714L431.979 115.359L420.334 103.714Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.601 127.056L455.246 115.411L466.892 127.056L455.246 138.701L443.601 127.056Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.296 127.019L431.941 115.374L443.587 127.019L431.941 138.664L420.296 127.019Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.275 92L373.631 103.645V92H385.275Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92 92H408.565L373.63 126.934V115.29L396.92 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21 92L373.631 138.745H385.275L420.21 103.645V92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.209 115.29L396.92 138.745H408.565L420.209 126.934V115.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14 126.935L291.951 138.746H280.14V126.935Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14 115.29V103.645L315.24 138.745H303.595L280.14 115.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14 92L326.885 138.745V126.934L291.951 92H280.14Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.596 92L326.885 115.29V103.645L315.24 92H303.596Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.815 115.29V138.579H210.105C210.271 125.77 199.791 115.29 186.815 115.29Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.526 138.745H186.815V115.29C174.006 115.29 163.526 125.77 163.526 138.745Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.815 162.035V138.745H163.526C163.526 151.554 174.006 162.035 186.815 162.035Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.271 138.746H186.981V162.035C199.791 162.035 210.271 151.555 210.271 138.746Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.136 103.645H128.425V126.934H105.136V103.645Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5567 103.645H81.8462V126.934H58.5567V103.645Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4907 162.035L70.2012 138.746L46.7453 162.035H93.4907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.129199 115.298L23.4197 92.0071L46.7102 115.298L23.4197 138.588L0.129199 115.298Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8921 115.298L23.5374 103.652L35.1826 115.298L23.5374 126.943L11.8921 115.298Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21 138.563V185.309H373.464V138.563H420.21Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.525 138.669V185.414H326.78V138.669H373.525Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.84 138.608V185.354H280.095V138.608H326.84Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.631 138.746V185.491H326.885C326.885 159.54 347.846 138.746 373.631 138.746Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.918 138.736L420.208 162.027L396.918 185.317L373.628 162.027L396.918 138.736Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.885 185.325L303.596 162.035L326.885 138.746V185.325Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9998 92.7459V46.0005L139.745 46.0005V92.7459H92.9998Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.684 92.8518V46.1064L186.429 46.1064V92.8518H139.684Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.368 92.7908V46.0454L233.113 46.0454V92.7908H186.368Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.661 92.6858L186.306 81.041V92.6858H174.661Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.016 92.6857H151.372L186.306 57.7515V69.3962L163.016 92.6857Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.727 92.6855L186.306 46.1064H174.661L139.727 81.0407V92.6855Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.727 69.396L163.016 46.1064H151.372L139.727 57.7512V69.396Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.318 92.7489L93.0283 69.4585L116.318 46.168L139.609 69.4585L116.318 92.7489Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05 46.1074L209.761 69.3969L233.05 92.6864V46.1074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.11 46.0002V92.7456H420.365V46.0002L467.11 46.0002Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.426 46.1055V92.8508H373.681V46.1055L420.426 46.1055Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.741 46.0449V92.7903H326.997V46.0449L373.741 46.0449Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.531 46.1824V92.9277H373.787C373.787 66.9766 394.747 46.1824 420.531 46.1824Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.531 57.8269V92.7612H385.598C385.431 73.4641 401.068 57.8269 420.531 57.8269Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.818 46.1732L467.109 69.4636L443.818 92.7541L420.528 69.4636L443.818 46.1732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.787 92.7614L350.498 69.4719L373.787 46.1824V92.7614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.428 46.0002V92.7456H233.683V46.0002L280.428 46.0002Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.112 46.061V92.8064H280.367V46.061L327.112 46.061Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.778 81.1772C297.347 81.1772 292.133 75.9637 292.133 69.5324C292.133 63.1012 297.347 57.8877 303.778 57.8877C310.209 57.8877 315.422 63.1012 315.422 69.5324C315.422 75.9637 310.209 81.1772 303.778 81.1772Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.033 57.7212C250.545 57.7212 245.388 62.8782 245.388 69.3659C245.388 75.8537 250.545 81.0107 257.033 81.0107C263.521 81.0107 268.677 75.8537 268.677 69.3659C268.677 63.0445 263.521 57.7212 257.033 57.7212Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 46.7459V0.000488281L372.745 0.000488281V46.7459L326 46.7459Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.684 46.8518V0.106445L419.429 0.106445V46.8518L372.684 46.8518Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.368 46.7908V0.0454102L466.113 0.0454102V46.7908L419.368 46.7908Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.661 46.6858L419.306 35.041V46.6858H407.661Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.016 46.6857L384.372 46.6857L419.306 11.7515V23.3962L396.016 46.6857Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.727 46.6855L419.306 0.106445L407.661 0.106445L372.727 35.0407V46.6855Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.727 23.396L396.016 0.106445L384.372 0.106445L372.727 11.7512V23.396Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.318 46.7489L326.028 23.4585L349.318 0.168024L372.609 23.4585L349.318 46.7489Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.05 0.107422L442.761 23.3969L466.05 46.6864V0.107422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.428 0.000232697V46.7456L466.683 46.7456V0.000232697L513.428 0.000232697Z",
    fill: "#D62340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 467,
    height: 139,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtmhomeright);
export default __webpack_public_path__ + "static/media/btmhomeright.97e1b072979ff2253fdcf070acb91a2b.svg";
export { ForwardRef as ReactComponent };